import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PORTAL_TOKEN_KEY = 'portal_token';
const PREVIEW_KEY = 'portal_preview_project_id';

// Preview mode (admin "Visualizar como cliente"): the project id arrives as
// ?preview=<id> and is kept per-tab in sessionStorage so navigation preserves it.
export const getPreviewId = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const p = params.get('preview');
    if (p) {
      sessionStorage.setItem(PREVIEW_KEY, p);
      return p;
    }
    return sessionStorage.getItem(PREVIEW_KEY);
  } catch (e) {
    return null;
  }
};

export const isPreview = () => !!getPreviewId();

// Dedicated axios instance — never shares the internal panel's auth header.
export const portalApi = axios.create({ baseURL: API_URL });

portalApi.interceptors.request.use((config) => {
  const preview = getPreviewId();
  if (preview) {
    const adminToken = localStorage.getItem('token');
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
    config.params = { ...(config.params || {}), preview_project_id: preview };
  } else {
    const t = localStorage.getItem(PORTAL_TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
    else delete config.headers.Authorization;
  }
  return config;
});

export const setPortalToken = (token) => localStorage.setItem(PORTAL_TOKEN_KEY, token);
export const clearPortalToken = () => {
  localStorage.removeItem(PORTAL_TOKEN_KEY);
  try { sessionStorage.removeItem('portal_reports_cache'); } catch (e) { /* ignore */ }
};
